//#region Util Imports

import * as _ from 'underscore'
import * as moment from 'moment'

//#endregion

//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import 'devextreme/ui/accordion'
import 'devextreme/ui/box'
import 'devextreme/ui/button'
import 'devextreme/ui/form'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/select_box'

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { LoggerService } from './../common/common.module'
import { CommonHelper } from '../../helpers/common-helper'
import { OperatorLayoutSettings } from '../../helpers/operator-layout-settings'
import { i18n } from '../common/i18n/common.i18n'
import { IUserSession } from '../../helpers/user-session'
import { ScriptModel, ScriptParamModel, ScriptGuidFormModel, ScriptGuidModel } from './../api/api.models'
import { GridOptions, GridTypes } from '../common/grid/grid.controller'
import { Md5 } from '../../helpers/md5-helper'
import { IMRBaseControlDirectiveController } from '../common/base'

interface ScriptsScope extends ng.IScope {
    mainBox: DevExpress.ui.dxBoxOptions
    scriptDetailsBox: DevExpress.ui.dxBoxOptions
    scriptSelectBox: any
    favButton: DevExpress.ui.dxButtonOptions
    favButtonComponent: DevExpress.ui.dxButton
    scriptSelectBoxComponent: DevExpress.ui.dxSelectBox
    scriptForm: DevExpress.ui.dxFormOptions
    scriptFormComponent: DevExpress.ui.dxForm
    runScriptButton: DevExpress.ui.dxButtonOptions
    runScriptButtonComponent: DevExpress.ui.dxButton
    gridsAccordion: DevExpress.ui.dxAccordionOptions

    isFormVisible: boolean
    isScriptChoosen: boolean
    scriptAuthor: string
    scriptDescr: string

    isScriptRunning: boolean
    isFormEmpty: boolean

    onPopoverValueIdSelected(valueId: number, datatypeId: number, selectedName: string, scriptArgName: string): void
    onFieldValueChanged(e: any): void
    onFieldValueArrayChanged(e: any): void

    gridDataSources: any[]
    showResult: boolean
    showError: boolean
    scriptExecTime: string
    wasScriptStopped: boolean

    errorMessage: string

    isLeftLoading: boolean
    isRightLoading: boolean
}

export class ScriptsController extends IMRBaseControlDirectiveController {
    private referenceTableCount: number = 0
    private scripts: any[]
    private favScripts: any[]
    private favIds: number[]
    private recentIds: number[]
    private recentScripts: any[]
    private scriptSelectBoxDeferred: ng.IDeferred<DevExpress.ui.dxSelectBox>
    private accordion: DevExpress.ui.dxAccordion
    private accordionDeferred: ng.IDeferred<DevExpress.ui.dxAccordion>
    private currentScript: any
    private scriptStatusTimeout
    private previousScriptMd5: string
    private requestFailed: boolean
    constructor(protected $scope: ScriptsScope, protected $state: StateService, protected $timeout: ng.ITimeoutService, protected $q: ng.IQService,
        protected api: Api, private logger: LoggerService, private localDictionary: LocalDictionaryFactory, protected userSession: IUserSession) {

        super()

        $scope.isFormVisible = false
        $scope.isScriptChoosen = false
        $scope.isScriptRunning = false
        $scope.isFormEmpty = false
        $scope.showResult = false
        $scope.showError = false
        $scope.gridDataSources = []
        $scope.wasScriptStopped = false
        this.currentScript = null

        $scope.isLeftLoading = false
        $scope.isRightLoading = false

        this.scriptSelectBoxDeferred = this.$q.defer<DevExpress.ui.dxSelectBox>()
        this.accordionDeferred = this.$q.defer<DevExpress.ui.dxAccordion>()
        $scope.$watch('isScriptRunning', (val) => {
            if ($scope.runScriptButtonComponent) {
                if (val) {
                    $scope.runScriptButtonComponent.option("text", i18n("Popup", "Stop"))
                } else {
                    $scope.runScriptButtonComponent.option("text", i18n("Common", "Run"))
                }
                $scope.runScriptButtonComponent.option("disabled", false)
            }
        })

        $scope.mainBox = {
            height: "100%",
            direction: "row"
        }

        $scope.scriptDetailsBox = {
            direction: "row",
        }

        api.scripts.getScripts().then(result => {
            if (result) {
                this.scripts = result.result
                this.favScripts = OperatorLayoutSettings.getSetting(CommonHelper.FAVORITE_SCRIPTS, new Array<any>())
                this.recentScripts = OperatorLayoutSettings.getSetting(CommonHelper.RECENT_SCRIPTS, new Array<any>())
                this.buildScriptDataSource()
            }
        })

        $scope.favButton = {
            icon: 'fa fa-star-o',
            hint: i18n("Common", "FavoritesAdd"),
            onClick: (e) => {
                var script: ScriptModel[] = this.scripts.filter(sc => sc.idDBScript == $scope.scriptSelectBoxComponent.option('value'))
                if (script[0]) {
                    if (this.favIds.indexOf(script[0].idDBScript) === -1) {
                        $scope.favButtonComponent.option('icon', 'fa fa-star')
                        $scope.favButtonComponent.option('hint', i18n("Common", "FavoritesAdd"))
                        this.favScripts.unshift(script[0])
                        this.buildScriptDataSource()
                    } else {
                        this.favScripts = this.favScripts.filter(sc => sc.idDBScript != script[0].idDBScript)
                        $scope.favButtonComponent.option('icon', 'fa fa-star-o')
                        $scope.favButtonComponent.option('hint', i18n("Common", "FavoritesRemove"))
                        this.buildScriptDataSource()
                    }
                    OperatorLayoutSettings.setSetting(CommonHelper.FAVORITE_SCRIPTS, this.favScripts)
                }
            },
            onInitialized: e => {
                $scope.favButtonComponent = e.component
            }
        }

        $scope.runScriptButton = {
            text: i18n("Common", "Run"),
            onClick: (e) => {
                e.component.option('disabled', true)
                if (!$scope.isScriptRunning) {
                    var formData = $scope.scriptFormComponent.option('formData')

                    var valResult = <any>$scope.scriptFormComponent.validate()
                    if (!valResult || (valResult && valResult.isValid)) {
                        this.prepareScriptToRun($scope.scriptFormComponent.option('formData'), $scope.scriptSelectBoxComponent.option('value'))
                    }
                    else {
                        $scope.scriptFormComponent.focus()
                        e.component.option('disabled', false)
                    }
                } else {
                    this.stopScript($scope.scriptFormComponent.option('formData'), $scope.scriptSelectBoxComponent.option('value'))
                }
            },
            onInitialized: e => {
                $scope.runScriptButtonComponent = e.component
            }
        }

        $scope.scriptForm = {
            onInitialized: (e) => {
                $scope.scriptFormComponent = e.component
            }
        }

        $scope.scriptSelectBox = {
            onInitialized: (e) => {
                $scope.scriptSelectBoxComponent = e.component
                this.scriptSelectBoxDeferred.resolve(e.component)
            },
            onValueChanged: (e) => {
                $scope.isScriptChoosen = false
                $scope.isFormVisible = false
                $scope.showResult = false
                $scope.showError = false
                if (e.value) {
                    if (this.isInFav(e.value)) {
                        $scope.favButtonComponent.option('icon', 'fa fa-star')
                        $scope.favButtonComponent.option('hint', i18n("Common", "FavoritesRemove"))

                    } else {
                        $scope.favButtonComponent.option('icon', 'fa fa-star-o')
                        $scope.favButtonComponent.option('hint', i18n("Common", "FavoritesAdd"))
                    }
                }
                var script: ScriptModel[] = this.scripts.filter(sc => sc.idDBScript == e.value)
                if (script[0]) {
                    $scope.scriptAuthor = script[0].authorName
                    $scope.scriptDescr = script[0].description
                    if (this.recentIds.indexOf(script[0].idDBScript) === -1) {
                        if (this.recentScripts.length < 3) {
                            this.recentScripts.unshift(script[0])
                        }
                        else {
                            this.recentScripts.pop()
                            this.recentScripts.unshift(script[0])
                        }
                    } else {
                        this.recentScripts = this.recentScripts.filter(sc => sc.idDBScript != script[0].idDBScript)
                        this.recentScripts.unshift(script[0])
                    }
                    this.buildScriptDataSource()
                    OperatorLayoutSettings.setSetting(CommonHelper.RECENT_SCRIPTS, this.recentScripts)
                    $timeout(() => {
                        this.createForm(script[0].arguments)
                    }, 500)
                }
            },
            grouped: true,
            valueExpr: 'idDBScript',
            displayExpr: 'name',
            groupTemplate: function (data) {
                return $("<div class='script-header-icon'><span class='" + data.icon + " icon'></span> " + data.key + "</div>");
            },
            noDataText: i18n('Common', 'NoData'),
            placeholder: i18n('Common', 'Select'),
            bindingOptions: {
                disabled: 'isScriptRunning'
            }

        }

        $scope.gridsAccordion = {
            height: '100%',
            multiple: false,
            disabled: false,
            collapsible: false,
            itemTitleTemplate: 'title',
            itemTemplate: 'panel',
            noDataText: "",
            onInitialized: e => {
                this.accordion = e.component
                this.accordionDeferred.resolve(e.component)
            },
            onSelectionChanged: e => {
                e.component.repaint()
            }
        }

        $scope.onPopoverValueIdSelected = (valueId: number, datatypeId: number = null, selectedName: string = null, scriptArg: any) => {
            $scope.scriptFormComponent.updateData(scriptArg, valueId)
        }

        $scope.onFieldValueChanged = (e: any) => {
            $scope.scriptFormComponent.updateData(angular.element(e.element).attr('id'), e.value)
        }

        $scope.onFieldValueArrayChanged = (e: any) => {
            $scope.scriptFormComponent.updateData(angular.element(e.element).attr('id'), e.value)
        }
    }

    private buildScriptDataSource() {

        this.recentIds = _.pluck(this.recentScripts, 'idDBScript')
        this.favIds = _.pluck(this.favScripts, 'idDBScript')
        var dSource = [{ key: i18n("Common", "Favorites"), items: this.favScripts, icon: 'fa fa-star' },
        { key: i18n("Common", "Recent"), items: this.recentScripts, icon: 'fa fa-history' },
        { key: i18n("Common", "All"), items: this.scripts, icon: 'fa fa-list' }]
        this.scriptSelectBoxDeferred.promise.then(() => {
            this.$scope.scriptSelectBoxComponent.option('dataSource', dSource)
        })
    }

    private createForm(args: ScriptParamModel[]) {
        var formData = []
        if (args) {
            args.forEach(arg => {
                var formDataItem = {};
                formDataItem[arg.fieldName] = arg.defaultValue ? arg.defaultValue : undefined
                formData.push(formDataItem)
            })
            this.$scope.scriptFormComponent.option('formData', formData)
            var promises = args.map(arg => this.createFormItem(arg))
            this.$scope.isLeftLoading = true
            var results = this.$q.all(promises).then(items => {
                this.$scope.scriptFormComponent.option('items', items)
                this.$scope.isFormVisible = true
                this.$scope.isLeftLoading = false
            })
            if (args.length === 0)
                this.$scope.isFormEmpty = true
            else this.$scope.isFormEmpty = false
        }
        this.$scope.isScriptChoosen = true
    }

    private createFormItem(arg: ScriptParamModel) {
        var itemDefer = this.$q.defer<DevExpress.ui.dxFormSimpleItem>()
        var formItem = <DevExpress.ui.dxFormSimpleItem>{}
        formItem.dataField = arg.fieldName
        formItem.label = { text: arg.name }
        formItem.visible = this.isItemVisible(arg)
        formItem.editorType = this.findItemEditorType(arg)
        if (arg.idDataTypeClass === CommonHelper.datetime) {
            formItem.editorOptions = <DevExpress.ui.dxDateBoxOptions>{
                type: "datetime",
                displayFormat: {
                    formatter: (value) => {
                        return moment(value).format(window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS'))
                    },
                    parser: (value) => {
                        return moment(value, window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')).toDate()
                    }
                },
                invalidDateMessage: i18n('Common', 'InvalidDate'),
                applyButtonText: i18n('Common', 'Done'),
                cancelButtonText: i18n('Common', 'Cancel')
            }
        }
        if (arg.idDataTypeClass === CommonHelper.date) {
            formItem.editorOptions = <DevExpress.ui.dxDateBoxOptions>{
                type: "date",
                displayFormat: {
                    formatter: (value) => {
                        return moment(value).format(window['simax'].getDateFormat('DATE_FORMAT_MOMENTJS'))
                    },
                    parser: (value) => {
                        return moment(value, window['simax'].getDateFormat('DATE_FORMAT_MOMENTJS')).toDate()
                    }
                },
                invalidDateMessage: i18n('Common', 'InvalidDate'),
                applyButtonText: i18n('Common', 'Done'),
                cancelButtonText: i18n('Common', 'Cancel'),
            }
        }
        formItem.validationRules = this.addItemValidationRules(arg)
        formItem.cssClass = 'data_type_' + arg.fieldName.substring(1)
        formItem.isRequired = false
        if (!formItem.editorOptions) {
            formItem.editorOptions = {}
        }
        formItem.editorOptions["onInitialized"] = (e) => {
            e.element.on("mouseenter", () => {
                e.element.find('.dx-overlay-wrapper.dx-invalid-message').css("visibility", "visible")
            })
            e.element.on("mouseleave", () => {
                e.element.find('.dx-overlay-wrapper.dx-invalid-message').css("visibility", "hidden")
            })
        }
        if (arg.idReference) {
            this.findItemTemplate(arg).then(template => {
                formItem.template = template
                itemDefer.resolve(formItem)
            })
        }
        else {
            itemDefer.resolve(formItem)
        }
        return itemDefer.promise
    }

    private isItemVisible(arg: ScriptParamModel) {
        return arg.isVisible
    }

    private findItemEditorType(arg: ScriptParamModel) {
        var editType
        switch (arg.idDataTypeClass) {
            case CommonHelper.date:
            case CommonHelper.datetime: {
                editType = 'dxDateBox'
                break
            }
            case CommonHelper.boolean: {
                editType = 'dxCheckBox'
                break
            }
            case CommonHelper.decimal:
            case CommonHelper.real: {
                editType = 'dxNumberBox'
                break
            }
            default: {
                editType = 'dxTextBox'
                break
            }
        }
        return editType
    }

    //gets form item template, based on promises to wait for select box template
    private findItemTemplate(arg: ScriptParamModel): ng.IPromise<string> {
        if (arg.idReference) {
            var defered = this.$q.defer<string>()
            var source = { dataMethod: '', scopeName: '', dictionaryMethod: '' }
            switch (arg.idReference) {
                case CommonHelper.IdLocation: {
                    source = { dataMethod: 'getLocations', scopeName: 'location', dictionaryMethod: 'getLocationSelectColumns' }
                    defered.resolve(this.getSelectPopoverTemplate(source, arg))
                }
                case CommonHelper.IdActor: {
                    source = { dataMethod: 'getContacts', scopeName: 'contact', dictionaryMethod: 'getActorSelectColumns' }
                    defered.resolve(this.getSelectPopoverTemplate(source, arg))
                }
                case CommonHelper.IdTaskGroup: {
                    source = { dataMethod: 'getReferenceObjectList', scopeName: 'app', dictionaryMethod: 'getTaskGroupSelectColumns' }
                    defered.resolve(this.getSelectPopoverTemplate(source, arg))
                }
                case CommonHelper.IdTariff: {
                    source = { dataMethod: 'getReferenceObjectList', scopeName: 'app', dictionaryMethod: 'getSimcardTariffSelectColumns' }
                    defered.resolve(this.getSelectPopoverTemplate(source, arg))
                }
                default: {
                    this.getSelectBoxTemplate(arg).then(template => {
                        var res: string = template
                        defered.resolve(res)
                    })
                }
            }
            return defered.promise
        }
    }

    //returns popover w/ grid template
    private getSelectPopoverTemplate(source: any, arg: ScriptParamModel) {
        return '<select-popover script-arg="' + arg.fieldName + '" selected-id="' + arg.defaultValue + '" source="{ dataMethod: \'' + source.dataMethod + '\', scopeName: \'' + source.scopeName + '\', dictionaryMethod: \'' + source.dictionaryMethod + '\' }" reference-type-id="' + arg.idReference + '" callback="::onPopoverValueIdSelected"></select-popover>'
    }

    //gets reference from dictionary and returns select box template
    private getSelectBoxTemplate(arg: ScriptParamModel) {
        return this.localDictionary.getSelectBoxData(arg.idReference).then(source => {
            this.referenceTableCount += 1
            this.$scope['referenceTable' + this.referenceTableCount] = source.selectBoxData
            if (!arg.isCollection) {
                return '<div id="' + arg.fieldName + '" dx-select-box="{dataSource: referenceTable' + this.referenceTableCount + ', placeholder:' + "'" + arg.name + "'" + ', value: ' + arg.defaultValue + ', valueExpr: \'id\', searchEnabled: true, displayExpr: \'caption\', onValueChanged: onFieldValueChanged }"></div>'
            } else {
                return '<div id="' + arg.fieldName + '" dx-tag-box="{dataSource: referenceTable' + this.referenceTableCount + ', placeholder:' + "'" + arg.name + "'" + ', value: ' + arg.defaultValue + ', valueExpr: \'id\', searchEnabled: true, displayExpr: \'caption\', onValueChanged: onFieldValueArrayChanged }"></div>'
            }
        })
    }

    //adds validation rules to form item based on its DataTypeClass (e.g Date, Bool, String)
    private addItemValidationRules(arg: ScriptParamModel) {
        var validationRules = []
        switch (arg.idDataTypeClass) {
            case CommonHelper.date: {
                validationRules.push({
                    type: "required",
                    message: i18n("Common", "RequiredField")
                })
                break
            }
            case CommonHelper.boolean: {
                validationRules.push({
                    type: "custom",
                    message: i18n("Common", "RequiredField"),
                    validationCallback: (options) => {
                        var val = options.value
                        if (val == undefined) {
                            return false
                        } else return true
                    }
                })
                break
            }
            case CommonHelper.integer: {
                validationRules.push({
                    type: "required",
                    message: i18n("Common", "RequiredField")
                })
                validationRules.push({
                    type: 'pattern',
                    pattern: '^[0-9]{0,}$',
                    message: i18n('Common', 'IntegerField')
                })
                validationRules.push({
                    type: 'stringLength',
                    max: 9,
                    message: i18n('Common', 'MaxNumberOfCharacters') + ' 9'
                })
                break
            }
            case CommonHelper.decimal:
            case CommonHelper.real: {
                validationRules.push({
                    type: "required",
                    message: i18n("Common", "RequiredField")
                })
                validationRules.push({
                    type: 'numeric',
                    message: i18n('Common', 'NumericField')
                })
                validationRules.push({
                    type: 'stringLength',
                    max: 9,
                    message: i18n('Common', 'MaxNumberOfCharacters') + ' 9'
                })
                break
            }
            default: {
                validationRules.push({
                    type: "required",
                    message: i18n("Common", "RequiredField")
                })
                break
            }
        }
        return validationRules
    }

    //starts script, returns script GUID
    private prepareScriptToRun(formData: any[], idDBScript: number) {
        var error = false
        var script: ScriptModel[] = this.scripts.filter(sc => sc.idDBScript == idDBScript)
        if (script[0]) {
            var selectedScript = _.clone(script[0])

            selectedScript.arguments.forEach(arg => {
                if (formData[arg.fieldName] !== null && formData[arg.fieldName] !== undefined) {
                    arg.value = formData[arg.fieldName]
                    $(".data_type_" + arg.fieldName.substring(1) + " .select-container").removeClass('dx-invalid dx-texteditor')
                    $(".data_type_" + arg.fieldName.substring(1) + " .select-button").removeClass('dx-invalid dx-texteditor')
                } else {
                    $(".data_type_" + arg.fieldName.substring(1) + " .select-container").addClass('dx-invalid dx-texteditor')
                    $(".data_type_" + arg.fieldName.substring(1) + " .select-button").addClass('dx-invalid dx-texteditor')
                    error = true
                    this.$scope.runScriptButtonComponent.option("disabled", false)
                }
            })
            if (!error) {
                this.$scope.wasScriptStopped = false
                const currentMd5 = Md5.init(selectedScript)
                if (this.previousScriptMd5 !== currentMd5 || this.requestFailed) {
                    this.previousScriptMd5 = currentMd5
                    this.api.scripts.scriptStart(selectedScript).then((result: ScriptGuidModel) => {
                        const guid = result.guid
                        const current = <any>selectedScript
                        current.guid = guid
                        this.currentScript = current
                        this.$scope.isScriptRunning = true
                        this.getScriptStatus(formData, idDBScript)
                        this.requestFailed = false
                    }).catch(err => {
                        this.requestFailed = true
                        console.log(err)
                    })
                } else {
                    this.$scope.runScriptButtonComponent.option("disabled", false)
                }
            }
        }
    }

    //stops script, returns script GUID
    private stopScript(formData: any[], idDBScript: number) {
        var formModel = this.getScriptData(formData, idDBScript)
        if (formModel) {
            clearTimeout(this.scriptStatusTimeout)
            this.api.scripts.scriptStop(formModel).then(result => {
                var guid = result.guid
                this.currentScript = null
                this.$scope.isScriptRunning = false
                this.$scope.isRightLoading = false
            }).catch(err => {
                console.log(err)
            })
        }
    }

    //checks if script is in favorites
    private isInFav(idDBScript: number) {
        return this.favIds.indexOf(idDBScript) > -1
    }

    //checks if script has finished (w/ error), shows result or error.
    private getScriptStatus(formData: any[], idDBScript: number) {
        var formModel = this.getScriptData(formData, idDBScript)
        if (this.$scope.isScriptRunning && formModel) {
            this.$scope.isRightLoading = true
            this.checkScriptStatus(formModel, formData, idDBScript)
        }
    }

    //checks status
    private checkScriptStatus(formModel: ScriptGuidFormModel, formData: any[], idDBScript: number) {
        if (this.$scope.isScriptRunning && formModel) {
            this.api.scripts.scriptStatus(formModel).then(result => {
                if (result.isScriptReady) {
                    clearTimeout(this.scriptStatusTimeout)
                    if (result.error === '' || !result.error) {
                        this.getScriptResult(formModel)
                    }
                    else {
                        this.$scope.isRightLoading = false
                        this.$scope.showError = true
                        this.$scope.errorMessage = result.error
                    }
                    this.$scope.isScriptRunning = false
                } else {
                    this.scriptStatusTimeout = setTimeout(() => {
                        this.checkScriptStatus(formModel, formData, idDBScript)
                    }, 500)
                }
            }).catch(err => {
                console.log(err)
            })
        }
    }

    //gets Script Result
    private getScriptResult(formModel: ScriptGuidFormModel) {
        this.api.scripts.getScriptResult(formModel).then(res => {
            if (res.executionTime !== "stop") {
                this.$scope.gridDataSources = []
                this.$scope.scriptExecTime = res.executionTime
                if (res && res.gridDataSource.length > 0) {
                    for (var i = 0, len = res.gridDataSource.length; i < len; i++) {
                        this.$scope.gridDataSources.push({
                            title: res.gridNames[i],
                            panel: <GridOptions>{
                                type: GridTypes.PAGINATED_SMALL,
                                name: 'sriptsGrid',
                                buttonsOptions: { enabled: true, isSelectButtonHidden: true },
                                dataSource: new DataSource(JSON.parse(res.gridDataSource[i])),
                                noDataText: i18n("Common", "NoResults")
                            }
                        })
                    }
                    this.accordionDeferred.promise.then(() => {
                        this.$timeout(() => {
                            this.accordion.option('dataSource', this.$scope.gridDataSources)
                            this.accordion.repaint()
                        })
                    })
                }
            }
            else {
                this.$scope.wasScriptStopped = true
            }
            this.$scope.isRightLoading = false
            this.$scope.showResult = true
        }).catch(err => {
            console.log(err)
        })
    }



    //creates Script GUID model to be passed to api
    private getScriptData(formData: any[], idDBScript: number) {
        if (this.currentScript) {
            var selectedScript = this.currentScript

            selectedScript.arguments.forEach(arg => {
                arg.value = formData[arg.fieldName]
            })

            var formModel: ScriptGuidFormModel = new ScriptGuidFormModel()
            formModel.guid = selectedScript.guid

            return formModel
        }
    }

    private createLoadingIndicator(parentEl: JQuery, isLeft: boolean) {
        var div = '<div id="loadingIndicatorGrid" style="display: -ms-flexbox; flex-direction: -ms-column;"></div>'
        var loadingIndicator = '<div id="indicator"></div>'
        parentEl.append(div)
        parentEl.find('#loadingIndicatorGrid').css({
            position: 'absolute',
            top: 0,
            left: isLeft ? 0 : '50%',
            height: '100%',
            width: '50%',
            'z-index': 999,
            background: '#fff',
            display: 'flex',
            'flex-direction': 'column',
            'align-items': 'center',
            'justify-content': 'center'
        }).append(loadingIndicator)
        parentEl.find('#indicator').dxLoadIndicator({
            width: 40,
            height: 40
        })
    }

    private removeLoadingIndicator(parentEl: JQuery) {
        parentEl.find('#loadingIndicatorGrid').remove()
    }
}